// Shared category picker for blog post editors. Value = one BLOG_CATEGORY
// (includes all PROBLEM_TAGS plus blog-only extras like 'video').
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BLOG_CATEGORIES, BLOG_CATEGORY_LABELS } from "@/lib/blog-categories";

interface BlogCategorySelectProps {
  value: string;
  onChange: (value: string) => void;
}

export function BlogCategorySelect({ value, onChange }: BlogCategorySelectProps) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Izaberite temu…" />
      </SelectTrigger>
      <SelectContent>
        {BLOG_CATEGORIES.map((tag) => (
          <SelectItem key={tag} value={tag}>
            {BLOG_CATEGORY_LABELS[tag]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
